
import { Image, get_prop } from 'utils'
import { FAKE_TERMINAL_ID } from 'main'

export default class Help extends PIXI.Container{
    constructor(config, space) {

        super();

        this.interactive = true;

        //const helpContainer = new PIXI.Container();

        this.pageSprite = new PIXI.Sprite();
        this.pageTextures = [];
        this._pagesNumber = config.help.pages;
        for (let i = 0; i < this._pagesNumber; ++i) {
            this.pageTextures.push(PIXI.utils.TextureCache[config.help.pageNameFormat.$(i)]);
        }
        this.addChild(this.pageSprite);

        this._currentPage = 0
        this.pageSprite.texture = this.pageTextures[this._currentPage];

        const terminalLabel = new PIXI.Text( '', { fontSize : 14, fill : config.help.terminalTextColor, align : 'center' } )
        terminalLabel.position.set(config.help.terminal_position.x, config.help.terminal_position.y);
        this.addChild(terminalLabel)
        space.s( 'terminal_id' ).on( id => terminalLabel.text = id.toString() );

        this.pagingSound = null;
        if (config.help.paging_sound) {
            this.pagingSound = sounds.get(config.help.paging_sound)
        }

        this.visible = false;
    }

    getPagesCount() {
        return this._pagesNumber;
    };

    /**
     * Returns current page number.
     * @returns {Number} Current page number
     * @memberOf HelpScene
     * */
    getCurrentPage() {
        return this._currentPage;
    };

    /**
     * Slides pages to next page.
     * @memberOf HelpScene
     * */
    nextPage(done) {
        if (this._currentPage < this.getPagesCount() - 1) {

            if (this.pagingSound) {
                this.pagingSound.play();
            }

            this._currentPage += 1;
            this.pageSprite.texture = this.pageTextures[this._currentPage]
            done();
        }
        else {
            done();
        }
    };

    /**
     * Slides pages to previous page.
     * @memberOf HelpScene
     * */
    previousPage(done) {
        if (this._currentPage > 0) {

            if (this.pagingSound) {
                this.pagingSound.play();
            }

            this._currentPage -= 1;
            this.pageSprite.texture = this.pageTextures[this._currentPage]
            done();
        }
        else {
            done();
        }
    };


    /**
     * Pauses scene.
     * @memberOf HelpScene
     * @override
     * */
    pause() {

    };

    /**
     * Resumes scene.
     * @memberOf HelpScene
     * @override
     * */
    resume() {

        this.pagingSound.mute(false);

        this._currentPage = 0;
        this.pageSprite.texture = this.pageTextures[this._currentPage]
    };

    /**
     * Makes price table.
     * @memberOf HelpScene
     * @private
     * */
    preparePricetable() {

    };

    /**
     * Updates price table values.
     * @memberOf HelpScene
     * */
    updatePricetable(lines, multiplier) {

    };


    // RX

    show(bet) {
        this.visible = true;
        this.resume();
        //this.updatePricetable(bet.lines, bet.multiplier);
    };

    hide() {
        this.visible = false;
        this.pause();
    };
}



// WEBPACK FOOTER //
// ./src/games/help.es6